import { DrawerShellFooter } from '@zrsystem/ui';
import {
  createContext,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

interface FormDrawerFooterSlotContextValue {
  setFooter: (node: ReactNode | null) => void;
}

const FormDrawerFooterSlotContext = createContext<FormDrawerFooterSlotContextValue | null>(null);

export function FormDrawerFooterSlotProvider({ children }: { children: ReactNode }) {
  const [footer, setFooter] = useState<ReactNode | null>(null);
  const value = useMemo(() => ({ setFooter }), []);

  return (
    <FormDrawerFooterSlotContext.Provider value={value}>
      {children}
      {footer ? <DrawerShellFooter>{footer}</DrawerShellFooter> : null}
    </FormDrawerFooterSlotContext.Provider>
  );
}

/** Registers drawer footer actions for the current FormDrawerHost instance. */
export function useFormDrawerFooterSlot(footer: ReactNode | null) {
  const context = useContext(FormDrawerFooterSlotContext);

  useLayoutEffect(() => {
    if (!context) {
      return;
    }
    context.setFooter(footer);
  }, [context, footer]);

  useLayoutEffect(() => {
    if (!context) {
      return;
    }
    return () => {
      context.setFooter(null);
    };
  }, [context]);
}
